import * as React from 'react';
export const TourGuideContext = React.createContext({
    canStart: { _default: false },
});
